import React from "react";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";

const GST_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const MyGST = ({
  title = "GST Number",
  name = "gst",
  register,
  setValue,
  errors,
  placeholder = "22ABCDE1234F1Z5",
  required = false,
  disabled = false,
  readonly = false,
}) => {
  const error = get(errors, name);

  const handleChange = (e) => {
    const value = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");

    setValue(name, value, { shouldValidate: true });
  };

  return (
    <div className="form-group">
      <MyLabel name={name} title={title} required={required} />

      <div className="form-control-wrap">
        <input
          type="text"
          id={name}
          placeholder={placeholder}
          maxLength={15}
          {...register(name, {
            required: required ? "GST number is required" : false,

            validate: (value) => {
              // ✅ optional field → allow empty
              if (!required && !value) return true;

              // ✅ required field → empty handled by required rule
              if (!value) return true;

              // ✅ validate only when value exists
              return (
                GST_REGEX.test(value) ||
                "Invalid GST format (22ABCDE1234F1Z5)"
              );
            },
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={handleChange}
          readOnly={readonly}
          disabled={disabled}
        />

        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyGST;
